import { Alert } from "antd"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import dayjs from "dayjs"
import apiClient from "../../Utils/apiClient"
import "./MaintenanceBanner.scss"

const MaintenanceBanner = () => {
  const userInfo = useSelector((state) => state.user.data)
  const [state, setState] = useState(null)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      try {
        const res = await apiClient("settings/maintenance?summary=1", "GET")
        if (!cancelled && res?.success) setState(res.result)
      } catch (err) {
        if (!cancelled) setState(null)
      }
    }
    load()
    const timer = setInterval(load, 30000)
    return () => {
      cancelled = true
      clearInterval(timer)
    }
  }, [])

  const isAdmin = userInfo?.role === "network-admin"
  const manage = isAdmin ? (
    <>
      {" "}
      <Link to="/maintenance">Manage maintenance</Link>
    </>
  ) : null

  if (state?.active) {
    const action = state.forceAction === "shutdown" ? "shut down" : "reboot"
    return (
      <div className="maintenance-banner">
        <Alert
          type="warning"
          showIcon
          message="Maintenance is on — keep your device powered on"
          description={
            <span>
              {state.message ||
                `Windows updates, app installs, and custom tasks are paused. Devices with jobs already running may ${action}.`}{" "}
              Please do not turn your device off during this period.
              {manage}
            </span>
          }
        />
      </div>
    )
  }

  if (state?.scheduled) {
    const next = state.nextWindowLabel
      ? state.nextWindowLabel
      : state.nextWindowStart
        ? dayjs(state.nextWindowStart).format("ddd D MMM, HH:mm")
        : null
    return (
      <div className="maintenance-banner">
        <Alert
          type="info"
          showIcon
          message="Maintenance is scheduled — keep your device powered on"
          description={
            <span>
              {state.windowLabel ? `Scheduled for ${state.windowLabel}. ` : ""}
              {next ? `Next start: ${next}. ` : ""}
              Please keep your device on and do not turn it off during this
              period.
              {manage}
            </span>
          }
        />
      </div>
    )
  }

  return null
}

export default MaintenanceBanner
